var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalCatatan",
    attrs: {
      "id": "modal-catatan",
      "title": "History Keputusan",
      "variant": "primary",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Petugas")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Keputusan")]), _vm._v(" "), _c('th', [_vm._v("Waktu Mulai")]), _vm._v(" "), _c('th', [_vm._v("Waktu Selesai")]), _vm._v(" "), _c('th', [_vm._v("Catatan")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.barpin.catatan), function(listCatatan) {
    return _c('tr', {
      key: listCatatan.WK_MULAI
    }, [_c('td', [_vm._v(_vm._s(listCatatan.nama_petugas == null ? '' : listCatatan.nama_petugas.NAMA))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.status_name.ur_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.FL_KEPUTUSAN === 'Y' ? 'Setuju' : (listCatatan.FL_KEPUTUSAN === 'T' ? 'Ditolak' : listCatatan.FL_KEPUTUSAN === 'X' ? 'Ditolak' :
      listCatatan.FL_KEPUTUSAN)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.WK_MULAI))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.WK_SELESAI))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listCatatan.KETERANGAN))])])
  }))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95a52592","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalCatatan.vue
// module id = 339
// module chunks = 0